import React from 'react';
import { MultiIdCombobox } from '@/components/ui/multi-id-combobox';

type Option = { label: string; value: string };

/**
 * Occupants of the selected ICS position who are named as responsible for
 * this task. Hidden until a position is chosen.
 */
export const ResponsibleIndividualsField: React.FC<{
  positionSelected: boolean;
  options: Option[];
  value: string[];
  onChange: (next: string[]) => void;
}> = ({ positionSelected, options, value, onChange }) => {
  if (!positionSelected) return null;
  const hasOccupants = options.length > 0;
  return (
    <div className="tw:space-y-1.5">
      <div className="tw:text-xs tw:font-semibold tw:tracking-wide tw:uppercase tw:text-muted-foreground">
        Responsible Individual(s)
      </div>
      <MultiIdCombobox
        options={options}
        value={value}
        onChange={onChange}
        placeholder={
          hasOccupants
            ? 'Who is responsible'
            : 'No one assigned to this position'
        }
      />
    </div>
  );
};
